import { render, staticRenderFns } from "./zdfzsh.vue?vue&type=template&id=f724afc0&scoped=true&"
import script from "./zdfzsh.vue?vue&type=script&lang=js&"
export * from "./zdfzsh.vue?vue&type=script&lang=js&"
import style0 from "./zdfzsh.vue?vue&type=style&index=0&id=f724afc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f724afc0",
  null
  
)

export default component.exports